import React from 'react';
import '../styles/IframeExample.css'

const IframeExample = () => {
  const dialogFrameSrc = `${process.env.PUBLIC_URL || ''}/iframes/jquery-dialog-demo.html`;

  return (
    <div className="iframe-example">
      <h1>Embedding an Iframe in React</h1>
      <p>Below is an embedded iframe example showing an external webpage:</p>

      <div className="iframe-text-field-wrap">
        <label htmlFor="dialog-text-field">Enter text</label>
        <input
          type="text"
          id="dialog-text-field"
          name="dialog_text"
          className="iframe-text-field"
          placeholder="Type something here"
        />
      </div>

      <iframe
        className="demo-frame"
        id="dialog-embed-frame"
        name="jquery-dialog-iframe"
        src={dialogFrameSrc}
        title="Example Website"
        width="100%"
        height="500px"
        style={{ border: '2px solid #ccc', borderRadius: '8px' }}
      >
        Your browser does not support iframes.
      </iframe>
    </div>
  );
};

export default IframeExample;
